import { request } from '@tencent/ppd-base-libs';
import { MerchantInfo } from '@tencent/wphk-components-wecoupon';
import { PageResult } from '@/types/we-coupons';
import { amount } from '@tencent/wphk-base-utils';

/**
 * 已收藏商户类型
 */
export type FavoritesSpInfo = MerchantInfo & {
  /** 商户红点 */
  redFlag: number,
};

/**
 * 已收藏商户列表接口响应
 */
export type MyFavoritesSpListRes = PageResult<FavoritesSpInfo> & {
  /** 已收藏TAB红点 */
  redFlag: number,
  /** 商户总数 */
  totalCount: number,
};

/**
 * 最新优惠券类型
 */
export type LatestCoupon = {
  /** 商户ID */
  spId: string,
  /** 优惠券名称 */
  couponName: string,
  /** 商户名称 */
  spName: string,
};

/**
 * 获取已收藏商户列表
 */
export async function getMyFavoritesSpList(offset: number, limit: number): Promise<MyFavoritesSpListRes> {
  const res = await request.get('/app/promotion/we_coupon/we_coupon_subc_splist.cgi', {
    params: {
      offset,
      limit,
    },
  });
  return {
    redFlag: +res.subc_red_flag,
    totalCount: +res.total_num,
    dataList: res.sp_array.map(item => ({
      spId: item.spid,
      spLogo: item.sp_logo,
      spName: item.sp_name,
      redFlag: +item.red_flag,
      totalValue: +amount.fen2Yuan(item.total_val),
      state: 1,
      currencyType: item.cur_type,
      totalCnt: +item.total_cnt,
    })),
  };
}

/**
 * 获取最新优惠券列表信息
 */
export async function getLatestCouponList(): Promise<LatestCoupon[]> {
  const res = await request.get('/app/promotion/we_coupon/we_coupon_subc_broadcast.cgi');
  return res.coupon_array.map(item => ({ spId: item.spid, spName: item.sp_name, couponName: item.coupon_name }));
}
